import * as React from 'react';
import { CheckboxButton } from '@cian/ui-kit';

import { penthouseTypeDescriptor } from '../../constants/descriptors';
import { isDescriptorActive } from '../../utils/filters';
import { connectToDescriptors, IDescriptorProps } from '../сonnectToDescriptors';
import { getEventChecked } from '@cian/newbuilding-utils';
import { TTypedThunkDispatch } from '../../types/thunk';
import { getOffersCount } from '../../actions/offersData';

export interface IPenthouseTypeProps extends IDescriptorProps<string> {
  getOffersCount(): void;
}

class PenthouseTypeComponent extends React.Component<IPenthouseTypeProps> {
  public shouldComponentUpdate(nextProps: IPenthouseTypeProps) {
    const { jsonQuery, descriptors } = this.props;
    const nextActiveDescriptor = nextProps.descriptors.find(descriptor =>
      isDescriptorActive(descriptor)(nextProps.jsonQuery),
    );
    const activeDescriptor = descriptors.find(descriptor => isDescriptorActive(descriptor)(jsonQuery));

    /* istanbul ignore next */
    const nextValue = nextActiveDescriptor ? nextActiveDescriptor.state : undefined;
    /* istanbul ignore next */
    const value = activeDescriptor ? activeDescriptor.state : undefined;

    return nextValue !== value;
  }

  public render() {
    const { jsonQuery, descriptors } = this.props;
    const activeDescriptor = descriptors.find(descriptor => isDescriptorActive(descriptor)(jsonQuery));
    const value = activeDescriptor ? activeDescriptor.state : undefined;

    return (
      <CheckboxButton label="Пентхаус" name="is_penthouse" onChange={this.handleChange} checked={value === 'On'} />
    );
  }

  private handleChange = (event: React.SyntheticEvent) => {
    const checked = Boolean(getEventChecked(event));

    this.props.actionCreator(
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.props.descriptors.find(d => {
        return (d.state === 'On') === checked;
        // убрали правило из конвенции и из tslint-config(https://cianru.atlassian.net/browse/CD-33534),
        // но забыли про test-utils, по этому пока  пишем с исключениями
      })!,
    )();
    this.props.getOffersCount();
  };
}

function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    getOffersCount: () => {
      dispatch(getOffersCount());
    },
  };
}

export const PenthouseType = connectToDescriptors(penthouseTypeDescriptor, mapDispatchToProps)(PenthouseTypeComponent);
